import { render, staticRenderFns } from "./JSelectMultiUser.vue?vue&type=template&id=83f20f4c&scoped=true"
import script from "./JSelectMultiUser.vue?vue&type=script&lang=js"
export * from "./JSelectMultiUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f20f4c",
  null
  
)

export default component.exports